import * as zod from 'zod';

export const InvalidConfiguration = zod.object({
  kind: zod.literal('InvalidConfiguration'),
  name: zod.string().default('Invalid configuration'),
  invalidConfiguration: zod.any(),
});

export type InvalidConfiguration = zod.infer<typeof InvalidConfiguration>;
